// Feature flags for development vs production
const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEV_MODE === 'true';

export const FEATURES = {
  // Navigation features
  SHOW_HOME_NAV: false, // Removed - Home and Events show same content
  SHOW_VENDORS_NAV: true,
  
  // Event tab features
  SHOW_EVENT_OVERVIEW_TAB: true, // Now enabled in production
  SHOW_VENDOR_LOGISTICS_TAB: false, // Hidden in production
  SHOW_TIMELINE_TAB: false, // Hidden in production (replaced by Checklist)
  SHOW_EVENT_NOTES_TAB: true, // Always enabled - event notes tab
  SHOW_TRANSPORT_TAB: isDevelopment,
  SHOW_ROOM_ASSIGNMENT_TAB: isDevelopment,
  SHOW_GIFTS_TAB: isDevelopment,
  
  // Messaging tabs - simplified to single "Messages" tab
  SHOW_AUTO_MESSAGES_TAB: false, // DEPRECATED - Old complex rule-based UI
  SHOW_SCHEDULED_MESSAGES_TAB: true, // New simple 3-step messaging
  SHOW_WEB_CHAT_TAB: false, // PERMA-HIDDEN - replaced by Inbox
  SHOW_USER_MESSAGES_TAB: false, // HIDDEN - will be replaced by Inbox
  SHOW_JOB_MANAGEMENT_TAB: false, // HIDDEN - internal debugging only
  SHOW_ALERTS_TAB: false, // DEPRECATED - Renamed to Messages

  // Always visible features
  SHOW_EVENTS_NAV: true,
  SHOW_RSVP_TAB: true,
  
  // Help and core features
  SHOW_HELP: true,
  SHOW_LOGOUT: true
};

export const isFeatureEnabled = (featureName) => {
  return FEATURES[featureName] || false;
};